export const CouponData = [
    {
        id:"251620c0-e31f-4523-8903-fa67eb6d18af",
        discount:"5",
        upto:"500",
        img: "https://media.istockphoto.com/photos/green-peas-or-matar-paneer-curry-picture-id1325272041?k=20&m=1325272041&s=612x612&w=0&h=uqZ5DzVOrMIQdV0vGYmoeB5ddT_TalXvvrkhojC81oE="
    },
    {
        id:"85e6ce6b-d558-49bb-b986-ad5f050adf85",
        discount:"10",
        upto:"900",
        img: "https://media.istockphoto.com/photos/chilli-paneer-indian-snack-food-picture-id1311491582?k=20&m=1311491582&s=612x612&w=0&h=mMtsrJ4smfUSfjSGnYATav1qRrURQDGg2CHA9ehb3mk="
    },
    {
        id:"84c3e57e-89e4-4883-ae05-b9f9a2dc8324",
        discount:"15",
        upto:"1300",
        img: "https://i.ytimg.com/vi/engCXfgTprQ/maxresdefault.jpg"
    },
    {
        id:"3ad4c112-a28c-4521-bd32-d4f19f01a9a8",
        discount:"20",
        upto:"1800",
        img: "https://media.istockphoto.com/photos/asian-chinese-fried-rice-with-vegetable-and-egg-with-chopsticks-picture-id172789635?b=1&k=20&m=172789635&s=170667a&w=0&h=Oy_wDWypzlxUByNK1dQ6HTpLTKEekKmXCd-hCFAAKA4="
    },
    {
        id:"f4217906-2d28-49b7-8679-6560b009fd19",
        discount:"25",
        upto:"2300",
        img: "https://static.fanpage.it/wp-content/uploads/sites/22/2017/07/crispy-fried-chicken.jpg"
    },
    {
        id:"502b2083-b3e2-464b-ac5a-4dffb242ddd7",
        discount:"30",
        upto:"2700",
        img: "https://static.toiimg.com/thumb/53556560.cms?imgsize=162177&width=800&height=800"
    },
    {
        id:"2c118ca0-e858-4cc5-b89f-1de90df2cab6",
        discount:"35",
        upto:"3000",
        img: "https://theyumyumclub.com/wp-content/uploads/2019/04/CTT-fy-2.png"
    },
    {
        id:"be3e6c5a-0fbb-4f8f-9ac0-3e36c6a70f55",
        discount:"40",
        upto:"3500",
        img: "https://vaya.in/recipes/wp-content/uploads/2018/03/Chicken-Singaporean-Fried-Rice.jpg"
    },
]